import type { StatsProvider, DailyStats } from './StatsProvider';
import { raceAbort } from './raceAbort';

export class D1StatsProvider implements StatsProvider {
  private inflight = new Map<string, Promise<DailyStats | null>>();

  async getDailyStats(date: string, signal?: AbortSignal): Promise<DailyStats | null> {
    if (signal?.aborted) {
      throw new DOMException('AbortError', 'AbortError');
    }
    let shared = this.inflight.get(date);
    if (!shared) {
      shared = this.fetchOnce(date).finally(() => this.inflight.delete(date));
      this.inflight.set(date, shared);
    }
    return signal ? raceAbort(shared, signal) : shared;
  }

  private async fetchOnce(date: string): Promise<DailyStats | null> {
    const attempt = (): Promise<Response> => fetch(`/api/stats/${date}`);
    let res = await attempt();
    if (res.status >= 500 && res.status < 600) {
      await new Promise((r) => setTimeout(r, 200 + Math.random() * 100));
      res = await attempt();
    }
    if (!res.ok) {
      throw new Error(`stats_${res.status}`);
    }
    const data = (await res.json()) as DailyStats | null;
    return data ?? null;
  }
}
